export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új BNO kód',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyRow'
            }, {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            }, {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "kod",
                label: "Kód",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 6,
                formRequired: true,
                formVisible: true
            },
            {
                name: "leiras",
                label: "Leírás",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                formRequired: true,
                formType: 'text',
                formSize: 6,
                formVisible: true
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "createdOn",
                label: "createdOn",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'date',
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'date',
            },
            {
                name: "createdBy",
                label: "createdBy",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "deleted",
                label: "deleted",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "companyId",
                label: "companyId",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
